import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
    SET_SEARCH_TERM,
    SET_SELECTED_PRODUCT_ID,
    SET_SEARCH_FIELD
} from './types';
import * as productsApi from '../../api/products';

export const setSearchTerm = (term) => ({
    type: SET_SEARCH_TERM,
    payload: term,
  });

export const setSelectedProductId = (id) => ({
    type: SET_SELECTED_PRODUCT_ID,
    payload: id,
});

export const setSearchField = (field) => ({
    type: SET_SEARCH_FIELD,
    payload: field,
});

  export const get_productos = (fecha_creacion, fecha_resolucion, currentPedidoId) => async dispatch => {
    try {
        const res = await productsApi.getProducts({ fecha_creacion, fecha_resolucion, current_pedido_id: currentPedidoId });

        if (res.status === 200) {
            dispatch({
                type: GET_PRODUCTS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_PRODUCTS_FAIL
            });
        }

    } catch (err) {
        dispatch({
            type: GET_PRODUCTS_FAIL
        });
    }
}

export const get_productos_admin = () => async dispatch => {
    try {
        const res = await productsApi.getAdminProducts();

        if (res.status === 200) {
            dispatch({
                type: GET_PRODUCTS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_PRODUCTS_FAIL
            });
        }
    } catch (err) {
        dispatch({
            type: GET_PRODUCTS_FAIL
        });
    }
}
export const updateProducto = (id, productData) => async dispatch => {
    try {
        const res = await productsApi.updateProduct(id, productData);

        if (res.status === 200) {
            dispatch({
                type: UPDATE_PRODUCT_SUCCESS,
                payload: res.data
            });
            return true;
        }
    } catch (err) {
        dispatch({
            type: UPDATE_PRODUCT_FAIL
        });
        return false;
    }
};
export const deleteProducto = (id) => async dispatch => {
    try {
        const res = await productsApi.deleteProduct(id);

        if (res.status === 204) {  // 204 No Content means the deletion was successful
            dispatch({
                type: DELETE_PRODUCT_SUCCESS,
                payload: id
            });
            return true;
        }
    } catch (err) {
        dispatch({
            type: DELETE_PRODUCT_FAIL
        });
        return false;
    }
};